














































import {Vue, Component} from 'nuxt-property-decorator'
import VueScrollTo from 'vue-scrollto'
import lodash from 'lodash'
import PresenceInline from '@/components/PresenceInline.vue'
import Stepper from '@/components/stepper/Stepper.vue'
import {warningNotification, successNotification, errorNotification} from '@/notifications'
import { ProgressIndicator } from '@frontend/components'
import {debounce} from '@/helpers'
import gateway from '@/gateway'
import Steps from './steps'
import { getDraftId } from './helpers'

@Component({
  components: {
    Stepper,
    ProgressIndicator,
    PresenceInline,
  },
  metaInfo() {
    return {
        title: 'Latest Layout'
    }
  },
})
export default class LatestLayoutView extends Vue {
  steps = Steps
  draftId: number | null = null
  activeStepIndex: number = 0
  highlightFields: boolean = false
  spotlight: any = {}
  spotlightJr: any = {}
  chartOfTheWeek: any = {}
  topStories: Array<any> = [{article: {publicTitle: ''}}, {article: {publicTitle: ''}}, {article: {publicTitle: ''}}]
  briefing = {items: []}

  created () {
    getDraftId((err, post) => {
      this.setData(err, post)
    })
  }

  delayedSave() {
    const vm = this
    return debounce(async function () {
      await vm.saveLayout()
    }, 10)()
  }

  isValid (step) {
    if (step === -1) {
      return true
    }
    switch (step) {
      case 0: {
        return (lodash.get(this, 'chartOfTheWeek.content')
          && lodash.get(this, 'spotlight.article.id')
          && lodash.get(this, 'spotlightJr.article.id')
        )
      }
      case 1: {
        return lodash.get(this, 'topStories[0].article.id')
          && lodash.get(this, 'topStories[1].article.id')
          && lodash.get(this, 'topStories[2].article.id')
      }
      case 2: {
        return true
      }
      default: {
        return false
      }
    }
  }

  setData (err, payload) {
    if (err) {
      if (err.response && err.response.status === 404) {
        this.$notify(warningNotification('The Homepage Layout Draft wasn\'t loaded correctly'))
      }
      return
    }

    lodash.has(payload, 'data.id')
    && (this.draftId = lodash.get(payload, 'data.id'))

    lodash.has(payload, 'data.latestRevision.sections')
    && this.populateLayout(lodash.get(payload, 'data.latestRevision.sections'))
  }

  highlightRequired () {
    this.highlightFields = true
    this.$notify(errorNotification('Please fill out all fields before continuing.'))
    setTimeout(() => this.highlightFields = false, 7000)
  }

  onUpdate (layoutSlice = {}) {
    this.populateLayout(layoutSlice)
    this.delayedSave()
  }

  populateLayout (layoutSlice = {}) {
    this.spotlight = lodash.get(layoutSlice, 'spotlight', this.spotlight)
    this.spotlightJr = lodash.get(layoutSlice, 'spotlightJr', this.spotlightJr)
    this.briefing = lodash.get(layoutSlice, 'briefing', this.briefing)
    this.topStories = lodash.get(layoutSlice, 'topStories', this.topStories)
    this.chartOfTheWeek = lodash.get(layoutSlice, 'chartOfTheWeek', this.chartOfTheWeek)
  }

  async saveLayout (notify = false) {
    if (!this.draftId) {
      console.log('no draft id')
      return
    }
    try {
      const responsePromise = gateway.post(
        `/cms/homepage/drafts/${this.draftId}/revisions`,
        {
          sections: {
            spotlight: {...this.spotlight, layout: 'standard-left'},
            spotlightJr: {...this.spotlightJr},
            briefing: this.briefing,
            topStories: this.topStories,
            chartOfTheWeek: this.chartOfTheWeek,
          },
        }
      )

      if (notify) {
        await responsePromise
        this.$notify(successNotification('Successfully saved.'))
      }
    } catch (error) {
      this.$notify(warningNotification('The Homepage Layout Draft wasn\'t saved.'))
    }
  }

  navigateToStep(index) {
    this.saveLayout()
    if (!this.isValid(index-1)) {
      return this.highlightRequired()
    } else {
      this.activeStepIndex = index
      this.scrollIntoView()
    }
  }

  async goBack() {
    await this.navigateToStep(Math.max(0, this.activeStepIndex - 1))
  }

  async goNext() {
    await this.navigateToStep(
      Math.min(this.steps.length - 1, this.activeStepIndex + 1)
    )
  }

  async publishDraft (noRedirect = false) {
    try {
      await this.saveLayout()
      await gateway.post(`/cms/homepage/drafts/${this.draftId}/publish`, {})

      this.$notify(successNotification('The New Homepage version has been published.'))

      if (!noRedirect) {
        await this.$router.go(0)
      }
    } catch (error) {
      this.scrollIntoView()
      this.$notify(errorNotification(error))
    }
  }

  async publishDraftGoTellimerToday () {
    try {
      await this.publishDraft(true)
      await this.$router.push({name: 'newsletters.create', query: {template: 'tellimer-today-latest-layout'}})
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    }
  }

  scrollIntoView () {
    const target: string | Element | null = document.querySelector('.latest-layout')
    target && VueScrollTo.scrollTo(target, 500)
  }
}
